

















































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Select from '@/components/Select.vue'
import PaymentMethods from '@/views/app/management/components/PaymentMethods.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Addresses from '@/views/app/management/components/Addresses.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import {
  EPaymentMethodType,
  EPaymentReceiptType,
  getIdFromEntityField,
  ICalculatedResidentAutoApplyPaymentItemDTO,
  IPayment,
  IResidentPaymentMethod,
  isNumber
} from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import { minus, plus, makeProcessingNotificationTimeout } from '@/utils/helpers'
import Card from '@/components/Card.vue'
import PaymentSurcharge from '@/views/app/payment/components/PaymentSurcharge.vue'
import { Debounce } from 'vue-debounce-decorator'
import MoneyInputV3 from '@/components/inputs/MoneyInputV3.vue'
import moment from 'moment'
import { PaymentsModule } from '@/store/modules/payments.module'
import Table from '@/components/tables/Table.vue'
import Confirm from '@/components/Confirm.vue'
import MoneyHelper from '@/utils/MoneyHelper'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: {
    Table,
    MoneyInputV3,
    PaymentSurcharge,
    Card,
    Addresses,
    Icon,
    Select,
    PaymentMethods,
    ErrorMessages,
    Confirm,
    LoaderWrapper
  }
})
export default class OneTime extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  user: User = Api.getUser() as User
  isConfirmationOpened: boolean = false

  EPaymentReceiptType: any = EPaymentReceiptType
  selectedPaymentMethod: IResidentPaymentMethod | null = null
  autoApplyPaymentItems: ICalculatedResidentAutoApplyPaymentItemDTO[] = []
  receipt: {
    receiptName: string,
    receiptType: EPaymentReceiptType,
    receiptAddress: string
  } | null = null

  errors: string[] = []
  scrollError: string = ''
  email_validation_errors: string[] = []
  filters: any = {}

  amount: number | null = null
  totalWithSurcharge: number = 0
  surchargeAmount: number = 0

  isLoading: boolean = false
  isSaving: boolean = false
  includeSurcharge: boolean = false
  includeECheckSurcharge: boolean = false

  config: ITableConfig = {
    usePagination: false,
    useQuery: false,
    fetchFunction: this.filterItems,
    debounceTime: 10,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: 0; right: 0; z-index: 2;',
      class: 'rounded-top-bottom'
    },
    rowClass: 'alignItems',
    columns: [
      {
        minWidth: '150px',
        width: 21,
        key: 'transactionName',
        searchKey: 'transactionName',
        label: 'Unpaid Line Item',
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-center',
        class: 'text-center',
        minWidth: '140px',
        width: 16,
        key: 'date',
        searchKey: 'date',
        label: 'Date',
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 16,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-center',
        class: 'text-right',
        minWidth: '120px',
        width: 20,
        key: 'distribution',
        searchKey: 'distribution',
        label: 'Distribution',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 20,
        key: 'due',
        searchKey: 'due',
        label: 'Balance Due',
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '50px',
        width: 7,
        key: 'actions',
        type: ETableColumnType.actions
      }
    ]
  }

  get residentId () {
    return this.$route.params.residentId
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get residentName () {
    return this.resident.firstName
  }

  get totalWithSurchargeAmount () {
    return plus(+this.totalAmountDistribution, this.surchargeAmount)
  }

  get isSurchargeIncluded () {
    return (this.includeSurcharge && this.isCCPaymentMethodSelected) ||
      (this.includeECheckSurcharge && this.isECheckPaymentMethodSelected)
  }

  get distributionErrors () {
    const errors: string[] = []
    if (this.differentBetweenDistributions > 0) {
      errors.push(`You’ve entered <b>$${this.differentBetweenDistributions}</b> more than is being paid. Please adjust distribution or change total amount paid.`)
    }
    if (this.differentBetweenDistributions < 0) {
      errors.push(`You’ve entered <b>$${Math.abs(this.differentBetweenDistributions)}</b> less than is being paid. Please adjust distribution or change total amount paid.`)
    }
    if (this.availableAutoApplyPaymentItems.findIndex((item: any) => Number(item.distribution) < 0) > -1) {
      errors.push('Distribution items should not have negative values')
    }
    return errors
  }

  getCurrencyForModal () {
    return MoneyHelper.format((this.includeSurcharge || this.includeECheckSurcharge) && this.differentBetweenDistributions === 0 ? this.totalWithSurchargeAmount : this.totalAmountDistribution, { decimal: '.', suffix: '', thousands: ',', precision: 2, prefix: '$' })
  }

  get openBalance () {
    return this.$store.state.resident.openBalance
  }

  get collectionReviewLink () {
    return this.$route.params.collectionReviewLink ? this.$route.params.collectionReviewLink : ''
  }

  get availableAutoApplyPaymentItems () {
    const numericFilters = ['due', 'distribution', 'amount']
    return this.autoApplyPaymentItems.filter((item: ICalculatedResidentAutoApplyPaymentItemDTO) => {
      if (this.filters.transactionName && (!item.transactionName || !new RegExp(`${this.filters.transactionName.toLowerCase()}`).test(item.transactionName.toLowerCase()))) {
        return false
      }

      for (const numericFilter of numericFilters) {
        if (!this.filters[numericFilter]) {
          continue
        }

        const [startVal, endVal] = this.filters[numericFilter].split(';').map((item: string) => Number(item))
        const itemVal = (item as any)[numericFilter].toFixed(2)

        if (!endVal) {
          if (itemVal.toString().indexOf(startVal.toString()) === -1) {
            return false
          }
        } else if (startVal.toFixed(2) > itemVal || endVal.toFixed(2) < itemVal) {
          return false
        }
      }

      if (this.filters.date && item.date) {
        const [startDate, endDate] = this.filters.date.split(';').map((item: string) => moment(item, 'MM/DD/YYYY'))
        const itemDate = moment(item.date, 'M/YYYY')
        if (itemDate.diff(startDate.startOf('month')) < 0 || itemDate.diff(endDate.startOf('month')) > 0) {
          return false
        }
      }

      if (item.amount < 0 && item.distribution === 0 && item.id) {
        return false
      }

      return true
    })
  }

  get differentBetweenDistributions () {
    if (!this.autoApplyPayment) {
      return 0
    }
    return minus(this.totalAmountDistribution, this.autoApplyPayment.total)
  }

  get autoApplyPayment () {
    return this.$store.state.resident.calculatedAutoApplyPayment
  }

  get totalAmountDistribution () {
    return this.autoApplyPaymentItems
      .reduce((total: number, item: ICalculatedResidentAutoApplyPaymentItemDTO) => plus(total, item.distribution), 0)
  }

  get totalRemainingAmount () {
    return Number.isNaN(this.amount as number) ? 0 : this.openBalance.total - this.validAmount
  }

  get validAmount () {
    return Number.isNaN(this.amount as number) ? 0 : this.amount as number
  }

  get creditDateOption () {
    const arr = [moment().add(1, 'months').format('M/YYYY')]
    for (let i = 0; i < 24; i++) {
      arr.push(moment().subtract(i, 'months').format('M/YYYY'))
    }
    return arr.map((item: any) => {
      return {
        key: item,
        value: item,
        content: item
      }
    })
  }

  get paymentPayerTypes () {
    return this.$store.state.payments.paymentPayerTypes
      ? this.$store.state.payments.paymentPayerTypes
      : []
  }

  get paymentPayerTypesOptions () {
    return this.paymentPayerTypes.map((item: any) => {
      return {
        key: item.payerType.id,
        value: item.payerType.id,
        content: 'Credit for ' + item.payerType.payer_name
      }
    })
  }

  get disableCredit () {
    return this.totalAmountDistribution > this.availableAutoApplyPaymentItems.reduce((p, c: any) => (c.isCredit ? p : p + c.amount), 0) && this.availableAutoApplyPaymentItems.filter((item: any) => item.isCredit).length < 2
  }

  async mounted () {
    this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    await Promise.all([
      this.paymentModuleInstance.getPaymentPayerTypes(getIdFromEntityField(this.resident.facility))
    ])
    await this.calculateAutoApplyPayment()
    setTimeout(() => this.$eventBus.$emit('loading:disable'), 300)
  }

  beforeDestroy () {
    this.residentModuleInstance.resetResidentAutoApplyPayment()
  }

  @Debounce(300)
  debounceCalculateAutoApplyPayment () {
    this.calculateAutoApplyPayment()
  }

  setPaymentMethod (paymentMethod: IResidentPaymentMethod) {
    this.selectedPaymentMethod = paymentMethod
    if (paymentMethod.type === EPaymentMethodType.ECHECK || !paymentMethod) {
      this.includeSurcharge = false
    }
  }

  get isECheckPaymentMethodSelected () {
    if (!this.selectedPaymentMethod) {
      return false
    }
    return this.selectedPaymentMethod.type === EPaymentMethodType.ECHECK
  }

  get isCCPaymentMethodSelected () {
    if (!this.selectedPaymentMethod) {
      return false
    }
    return this.selectedPaymentMethod.type === EPaymentMethodType.CREDIT_CARD
  }

  findMatchingLineItemsByTed (item: any) {
    const normalizeDate = (date: string) => moment(date, ['M/YYYY', 'M/DD/YYYY']).format('M/YYYY')
    return this.autoApplyPaymentItems.filter(li => {
      if (li === item) return false
      const dateMatch = normalizeDate(li.date) === normalizeDate(item.date)
      const payerMatch = li.payerType && getIdFromEntityField(li.payerType) === getIdFromEntityField(item.payerType)
      return dateMatch && payerMatch
    })
  }

  prefillCredit (item: any) {
    if (!item.payerType || !item.date) {
      return
    }
    const matchingLineItem = this.findMatchingLineItemsByTed(item)[0] || {}
    item.amount = matchingLineItem.amount || 0
    item.due = matchingLineItem.due || 0
    item.distribution = 0
  }

  recalculateAllDues () {
    const visited = new Set()

    this.autoApplyPaymentItems.forEach((item: any) => {
      if (visited.has(item)) {
        return
      }
      const lineItemsGroup = [item, ...this.findMatchingLineItemsByTed(item)]
      const totalDistribution = lineItemsGroup.reduce((sum: number, li: any) => plus(sum, li.distribution), 0)
      const due = minus(item.amount, totalDistribution)

      lineItemsGroup.forEach(li => {
        li.due = due
        visited.add(li)
      })
    })

    this.$forceUpdate()
  }

  filterItems (filters: any) {
    // const filtersTmp = {...filters}
    // filtersTmp
    this.filters = { ...filters }
  }

  async calculateAutoApplyPayment () {
    try {
      if (this.$refs.table) {
        // @ts-ignore
        this.$refs.table.isLoading = true
      }
    } finally {
      await this.residentModuleInstance.getResidentAutoApplyPaymentCalculation({
        residentId: this.residentId,
        amount: this.validAmount
      })
      this.autoApplyPaymentItems = []
      if (this.autoApplyPayment && this.autoApplyPayment.items) {
        this.autoApplyPaymentItems = [...this.autoApplyPayment.items]
      }
      if (this.$refs.table) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.table.isLoading = false
          this.errors = []
        })
      }
    }
  }

  // changeApplyMode (item: ISelectItem) {
  //   this.mode = item.value
  //   this.autoApplyPaymentItems = this.autoApplyPayment ? [...this.autoApplyPayment.items] : []
  // }

  setReceipt (receipt: any) {
    this.receipt = receipt
  }

  addCredit () {
    this.autoApplyPaymentItems.push({
      isCredit: true,
      date: '',
      payerType: null,
      amount: 0,
      due: 0,
      distribution: 0
    })
  }

  removeItem (index: number) {
    if (this.disableCredit) {
      return
    }
    this.autoApplyPaymentItems.splice(index, 1)
  }

  validate () {
    this.errors = []
    // We can only scroll to one error so we only need to keep track of one of them.
    // Being that we want to scroll to the highest error, we'll check for errors in order of the page and only update the scrollError if it isn't set yet.
    this.scrollError = ''
    if ((this.amount && this.amount <= 0) || !this.amount || isNaN(Number(this.amount))) {
      this.scrollError = 'payment'
      this.errors.push('invalidAmount')
    }

    if (this.amount && this.amount > 0 && isNumber(this.totalAmountDistribution) && this.totalAmountDistribution !== this.amount) {
      this.scrollError = 'payment'
      this.errors.push('Total amount distribution must be equal to one-time payment amount')
    }

    if (this.differentBetweenDistributions !== 0) {
      if (!this.scrollError) this.scrollError = 'payment'
      this.errors.push('differentBetweenDistributions')
    }

    if (this.autoApplyPaymentItems.findIndex((item: any) => Number(item.distribution) < 0) > -1) {
      if (!this.scrollError) this.scrollError = 'payment'
      this.errors.push('negativeDistribution')
    }

    if (!this.user.isResident() &&
      (this.autoApplyPaymentItems.findIndex((item: any) => !item.date && item.isCredit) > -1 ||
      this.autoApplyPaymentItems.findIndex((item: any) => !item.payerType && item.isCredit) > -1)
    ) {
      if (!this.scrollError) this.scrollError = 'credit-line'
      this.errors.push('missingCreditData')
    }

    if (!this.selectedPaymentMethod) {
      if (!this.scrollError) this.scrollError = 'payment-method'
      this.errors.push('missingPaymentMethod')
    }

    return this.errors.length === 0
  }

  toggleConfirmationModal (val = false) {
    this.isConfirmationOpened = val
  }

  showConfirmationModal () {
    if (!this.validate() || this.isSaving) {
      if (this.scrollError) {
        const el = this.scrollError === 'credit-line' ? document.getElementsByClassName('validation')[0] : document.getElementById(this.scrollError)
        el && el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }
      return
    }
    this.toggleConfirmationModal(true)
  }

  async pay () {
    this.toggleConfirmationModal(false)
    if (!this.validate() || this.isSaving) {
      return
    }
    const paymentMethodId = this.selectedPaymentMethod && this.selectedPaymentMethod.id ? this.selectedPaymentMethod.id : this.selectedPaymentMethod
    let payment: any = {
      amount: this.totalAmountDistribution,
      resident: parseInt(this.residentId),
      residentPaymentMethod: paymentMethodId,
      includeSurcharge: this.includeSurcharge,
      includeECheckSurcharge: this.includeECheckSurcharge
    }
    if (this.receipt) {
      payment = { ...payment, ...this.receipt }
    }
    this.isSaving = true
    const timeout = makeProcessingNotificationTimeout(this, `Please don't refresh. Transaction is still processing.`, 3000)
    const response: { status: string, message: any, payment: IPayment } =
      await this.residentModuleInstance.makeOneTimePayment({
        residentId: this.residentId,
        data: {
          payment,
          transactions: this.autoApplyPaymentItems
            .filter(({ distribution }) => distribution > 0)
            .map(({ distribution, id, isCredit, payerType, date }: any) => ({
              amount: distribution,
              transactionEffectiveDate: id,
              isCredit: isCredit || false,
              payerType: payerType || null,
              date: date || null
            }))
        }
      })
    clearTimeout(timeout)
    if (response.status !== 'Failed' && response.payment) {
      this.$router.push({
        name: this.user.isResident() ? 'resident-portal-payment-one-time-success' : 'payment-one-time-success',
        params: {
          residentId: this.residentId,
          paymentId: response.payment.id.toString()
        },
        query: {
          collectionReviewLink: !this.user.isResident() ? this.collectionReviewLink : ''
        }
      })
      return
    }
    if (!response.payment) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message.join('\n'),
        header: 'Make Payment',
        icon: 'warning'
      })
    }
    if (response.payment) {
      this.$router.push({
        name: this.user.isResident() ? 'resident-portal-payment-one-time-failure' : 'payment-one-time-failure',
        params: {
          residentId: this.residentId,
          paymentId: response.payment.id.toString()
        },
        query: {
          collectionReviewLink: !this.user.isResident() ? this.collectionReviewLink : ''
        }
      })
    }
    this.isSaving = false
  }
}

